export const TOGGLE_LABEL_MARGIN = {
  xs: '6px',
  md: '8px',
  xl: '10px'
};
export const TOGGLE_WIDTH = {
  xs: '34px',
  sm: '34px',
  md: '37px',
  lg: '42px',
  xl: '48px'
};
export const TOGGLE_HEIGHT = {
  xs: '20px',
  sm: '20px',
  md: '22px',
  lg: '24px',
  xl: '28px'
};
export const TOGGLE_CIRCLE_SIZE = {
  xs: '16px',
  sm: '16px',
  md: '18px',
  lg: '20px',
  xl: '24px'
};
export const TOGGLE_CIRCLE_OFFSET = '2px';
export const TOGGLE_CIRCLE_TRANSFORM_OFFSET = {
  xs: '14px',
  sm: '14px',
  md: '15px',
  lg: '18px',
  xl: '20px'
};